import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {lastValueFrom, Observable} from 'rxjs';
import {CommonService} from "../services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../state/app.state";
import {v1URL} from "../constants/urls.constants";
import {HttpClient} from "@angular/common/http";
import {roleUrlMap, step} from "../constants/common.constants";
import {SetProfile} from "../core/shared.actions";

@Injectable({
  providedIn: 'root'
})
export class RegisterStepOneGuard {
  constructor(
    private router: Router,
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private http?: HttpClient,
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {
    let response: any;

    const removeOnboardingTokens = () => {
      this.commonService.removeRegisterToken();
      this.commonService.removeRegisterOtpToken();
      this.commonService.removeOnboardingToken();
    }

    if (route.queryParams?.['token']) {
      this.commonService.setRegisterToken(route.queryParams?.['token']);
    }

    const url = v1URL.user.registration['onboarding-step'].url;
    const method = v1URL.user.registration['onboarding-step'].method;

    try {
      response = await lastValueFrom(this.http[method](url));

      const onGoingStep = response.data.onGoingStep;

      if (response.data && onGoingStep === step["step-1"]) {
        return true;
      }


      if (onGoingStep === step['step-6']) {
        removeOnboardingTokens();

        if (response.data.profile) {
          const profile = {
            ...response.data.profile,
            roleName: response.data.profile.role.value,
            role: response.data.profile.role.key,
          }
          this.store.dispatch(SetProfile({profile}));
        }

        if (response.data.token) {
          this.commonService.setAuthenticationToken(response.data.token);
        }
        this.router.navigate([`/${roleUrlMap[response.data.role]}`]);
        return false;
      }

      if (onGoingStep <= step['step-5'] && onGoingStep >= step['step-1']) {
        this.router.navigate([`auth/register/step-${onGoingStep}`]);
      }

      if (onGoingStep === step['step-warning']) {
        this.router.navigate([`auth/step-warning`])
      }
    } catch(e) {
      this.router.navigate(['/auth/login']).then(() => {
        this.commonService.clearStorage();
      });
    }

    return false;
  }
}
